import {
  RENTAL_ADMIN_NEWREGISTRATION_DETAIL_SUCCESS,
  RENTAL_ADMIN_NEWREGISTRATION_DETAIL_ERROR,
  RENTAL_ADMIN_NEWREGISTRATION_DETAIL_START,
  CLEAR_PREVIOUS_REDUCER,
} from "Constant";
const initialState = {
  loading: false,
  data: [],
  address_data: [],
};

export default function NewRegistrationDetailReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case RENTAL_ADMIN_NEWREGISTRATION_DETAIL_START:
      return {
        ...state,
        loading: true,
      };
    case RENTAL_ADMIN_NEWREGISTRATION_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case RENTAL_ADMIN_NEWREGISTRATION_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
        data: [],
      };
    case CLEAR_PREVIOUS_REDUCER:
      return {
        ...state,
        data: [],
        loading: false,
        address_data: [],
      };
    default:
      return state;
  }
}
